import { render, staticRenderFns } from "./Lives.vue?vue&type=template&id=d99cfb7c&scoped=true&"
import script from "./Lives.vue?vue&type=script&lang=js&"
export * from "./Lives.vue?vue&type=script&lang=js&"
import style0 from "./Lives.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Lives.vue?vue&type=style&index=1&id=d99cfb7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99cfb7c",
  null
  
)

export default component.exports